module.exports = __webpack_public_path__ + "static/vivek.06ca52ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vivek.jpg
// module id = 468
// module chunks = 35783957827783